import { get } from '../httpClient';

export const organizationProfilesAPI = {
  show: params => get('/api/organization-profiles/show', params),
  query: params => get('/api/organization-profiles/query', params),
};